import * as actions from '../actions/profileViewActions'
import * as h2Api from '../h2Api'
import * as contentSnippetWizardActions from '../actions/contentSnippetWizard'
import { TOGGLE_PROMOTION } from '../actions/admin/adminCertificationActions'

const initialState = {
  profile: {},
  profileEditError: null,
  eventEditError: null,
  stats: {},
  selectedModal: null,
  userSurveyModalOpen: false,
  permissions: {
    modalOpen: false,
    data: []
  },
  editModalOpen: false,
  selectedEditPanel: 2,
  isDragging: false,

  clusterSuggestions: h2Api.initialRestState({ result: [] }),
  tagSuggestions: h2Api.initialRestState({ result: [] })
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.TOGGLE_DRAG:
      return {
        ...state,
        isDragging: action.isDragging
      }

    case actions.SELECT_MODAL_PROFILE:
      return {
        ...state,
        selectedModal: action.modalName
      }

    case actions.RATE_PROFILE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result
        const { rating, ...itms } = state.profile.personalization

        return {
          ...state,
          profile: {
            ...state.profile,
            personalization: {
              ...itms,
              ...action.restCall.result
            }
          }
        }
      }

      return state

    case actions.APPLY_FOR_PROFILE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          profile: {
            ...state.profile,
            personalization: {
              ...state.profile.personalization,
              interestExpression: action.restCall.result
            }
          }
        }
      }

      return state

    case actions.LOAD_PROFILE:
      switch (action.restCall.status) {
        case h2Api.REST_CALL_STATUS.FETCHING:
          return {
            ...state,
            isLoading: true,
            profile: null,
            profileEditError: null
          }
        case h2Api.REST_CALL_STATUS.RECEIVED:
          return {
            ...state,
            isLoading: false,
            profile: action.restCall.result,
            profileEditError: null
          }
        case h2Api.REST_CALL_STATUS.ERROR:
          return {
            ...state,
            isLoading: false,
            profileEditError: action.restCall.response
          }
        default:
          return state
      }

    case actions.CLUSTER_SEARCH_UPDATE:
      return {
        ...state,
        clusterSuggestions: {
          ...h2Api.handleRest(action, { result: [] }, state.clusterSuggestions)
        }
      }

    case actions.TAGS_SEARCH_UPDATE:
      return {
        ...state,
        tagSuggestions: {
          ...h2Api.handleRest(action, { result: [] }, state.tagSuggestions)
        }
      }

    case actions.TOGGLE_ACTIVE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          profile: {
            ...state.profile,
            active: action.restCall.result.active
          }
        }
      }

      return state

    case actions.TOGGLE_SURVEY_MODAL: {
      return {
        ...state,
        userSurveyModalOpen: action.opened
      }
    }

    case actions.LOAD_PROFILE_STATS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          stats: action.restCall.result
        }
      }

      return state

    case actions.TOGGLE_EDIT_MODAL:
      return {
        ...state,
        editModalOpen: action.state
      }

    case actions.DELETE_SECTION:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          profileEditError: null,
          profile: {
            ...state.profile,
            sections: [
              ...state.profile.sections.filter(
                s => s.id !== action.restCall.result.sectionId
              )
            ]
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.ERROR) {
        return {
          ...state,
          profileEditError: action.restCall.response
        }
      }

      return state

    case TOGGLE_PROMOTION:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          profile: {
            ...state.profile,
            promoted: action.restCall.result
          }
        }
      }

      return state

    case actions.TOGGLE_TAB:
      return {
        ...state,
        selectedEditPanel: action.selectedTab
      }

    case actions.UPLOAD_DATA:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          profile: action.restCall.result
        }
      }

      return state

    case actions.LOAD_PERMISSIONS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          permissions: {
            data: action.restCall.result
          }
        }
      }

      return state

    case actions.ADD_PERMISSIONS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          permissions: {
            data: [...state.permissions.data, action.restCall.result].sort((a, b) => {
              if (a.userName < b.userName) {
                return -1
              }

              if (a.userName > b.userName) {
                return 1
              }

              return 0
            }),
            modalOpen: true
          }
        }
      }

      return state

    case actions.TOGGLE_PERMISSIONS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const newP = action.restCall.result.newPermission

        return {
          ...state,
          permissions: {
            data: [
              ...state.permissions.data.filter(p => p.id != (newP || { id: -1 }).id),
              newP
            ].sort((a, b) => {
              if (a.userName < b.userName) {
                return -1
              }

              if (a.userName > b.userName) {
                return 1
              }

              return 0
            }),
            modalOpen: true
          }
        }
      }

      return state

    case actions.DELETE_PERMISSIONS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          permissions: {
            data: state.permissions.data.filter(
              p => p.id != action.restCall.result.deletedId
            ),
            modalOpen: true
          }
        }
      }

      return state

    case actions.CLEAR_EVENT_ERROR:
      return {
        ...state,
        eventEditError: null
      }

    case actions.SAVE_EVENT:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          eventEditError: null,
          profile: {
            ...state.profile,
            sections: [
              ...state.profile.sections.filter(s => s.id !== action.restCall.result.id),
              action.restCall.result
            ]
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.ERROR) {
        return {
          ...state,
          eventEditError: action.restCall.response
        }
      }

      return state

    case actions.DISMISS_PERMISSION_MODAL:
      return {
        ...state,
        permissions: {
          ...state.permissions,
          modalOpen: false
        }
      }

    case actions.CLOSE_SETUP_MODAL:
      return {
        ...state,
        profile: {
          ...state.profile,
          setup: true
        }
      }

    case actions.REORDER_SECTION:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          profile: {
            ...state.profile,
            sections: action.restCall.result
          }
        }
      }

      return state

    case contentSnippetWizardActions.CONTENT_WIZARD_SUBMIT:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        // this will close and reset the dialog
        const newSection = action.restCall.result.section
        const newSectionId = action.existingId
          ? action.existingId
          : newSection
          ? newSection.id
          : -1
        const rV = {
          ...state,
          profile: {
            ...state.profile,
            sections: [
              ...state.profile.sections.filter(s => s.id != newSectionId),
              newSection
            ]
          }
        }

        return rV
      }

      return {
        ...state,
        submitInProgress: true
      }
  }

  return state
}
